import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import CardList from '@/components/CardList'
import Section from '@/components/Section'

import RowItem from './components/RowItem'
import isWeblinkAction from './utils'

const mapApiItemsToCardList = apiItems => {
  if (!apiItems || !Array.isArray(apiItems)) {
    return []
  }

  return apiItems.map((item, index) => ({
    id: item.type || `row-${index}`,
    title: item.title || '',
    actions: item.actions || {},
    assets: item.assets || {},
    route: item.actions?.default?.url || null,
    showArrow: !!item.assets?.trailingIcon || true
  }))
}

const RowListCard = ({ data }) => {
  const navigate = useNavigate()

  const mappedItems = useMemo(() => {
    return mapApiItemsToCardList(data?.components?.items)
  }, [data?.components?.items])

  const handleItemClick = item => {
    const defaultAction = item?.actions?.default
    const url = defaultAction?.url
    if (!url) return

    if (isWeblinkAction(defaultAction)) {
      window.open(url, '_blank', 'noopener,noreferrer')
    } else {
      navigate(url)
    }
  }

  const renderItem = item => {
    return <RowItem item={item} onClick={handleItemClick} />
  }

  return (
    <Section title={data?.title}>
      <CardList items={mappedItems} renderItem={renderItem} />
    </Section>
  )
}

export default RowListCard
